/**
 * Stripe Price ID configuration — TEST MODE.
 * Before going live, swap these with live-mode price IDs.
 */

export const STRIPE_PRICES = {
  pro: {
    monthly: 'price_1T3loMPWYA39xYzxQUaHvxgi',
    yearly: 'price_1T3lpEPWYA39xYzxQGgbsWHk',
  },
  coach: {
    monthly: 'price_1T3lqRPWYA39xYzxrBenjSSo',
    yearly: 'price_1T3lrEPWYA39xYzxrwbCqx5Z',
  },
  club_starter: {
    monthly: 'price_1T3lw4PWYA39xYzx9yVoZAC1',
    yearly: 'price_1T3lwaPWYA39xYzx7BVC0ppp',
  },
  club_growth: {
    monthly: 'price_1T3lxTPWYA39xYzxPiUZXZVV',
    yearly: 'price_1T3ly4PWYA39xYzx7WA9MQF8',
  },
  club_performance: {
    monthly: 'price_1T3lyePWYA39xYzxeQz8MWje',
    yearly: 'price_1T3lzFPWYA39xYzxLpZReNyS',
  },
  club_elite: {
    monthly: 'price_1T3lznPWYA39xYzxFr14szyV',
    yearly: 'price_1T3m0KPWYA39xYzx9HZ8Wm0K',
  },
} as const;

/** Map from internal plan ID to Stripe price lookup */
export function getStripePriceId(
  planId: string,
  interval: 'monthly' | 'yearly',
): string | null {
  const entry = STRIPE_PRICES[planId as keyof typeof STRIPE_PRICES];
  if (!entry) return null;
  return entry[interval];
}

/**
 * STRIPE_PRICE_MAP — JSON for the webhook edge function secret.
 * Maps every price ID → internal plan name.
 * Set this as the STRIPE_PRICE_MAP secret in Supabase Edge Functions.
 */
export const STRIPE_PRICE_MAP_JSON = JSON.stringify({
  'price_1T3loMPWYA39xYzxQUaHvxgi': 'pro',
  'price_1T3lpEPWYA39xYzxQGgbsWHk': 'pro',
  'price_1T3lqRPWYA39xYzxrBenjSSo': 'coach',
  'price_1T3lrEPWYA39xYzxrwbCqx5Z': 'coach',
  'price_1T3lw4PWYA39xYzx9yVoZAC1': 'club_starter',
  'price_1T3lwaPWYA39xYzx7BVC0ppp': 'club_starter',
  'price_1T3lxTPWYA39xYzxPiUZXZVV': 'club_growth',
  'price_1T3ly4PWYA39xYzx7WA9MQF8': 'club_growth',
  'price_1T3lyePWYA39xYzxeQz8MWje': 'club_performance',
  'price_1T3lzFPWYA39xYzxLpZReNyS': 'club_performance',
  'price_1T3lznPWYA39xYzxFr14szyV': 'club_elite',
  'price_1T3m0KPWYA39xYzx9HZ8Wm0K': 'club_elite',
});
